import { useContext } from 'react';
import { DatasetContext } from '../../context/DatasetContext/DatasetContext';

export const useDatasetContext = () => {
  const context = useContext(DatasetContext);

  if (context.isProvided === false) {
    throw new Error('useDataset must be used within a DatasetContextProvider');
  }

  return context;
};
